import templateUrl from './timepicker.html';

export const timepickerComponent = {
    bindings: {
        details: '<',
        onTimeChange: '&'
    },
    templateUrl,
    controller: class TimepickerComponent {
        $onInit() {
            this.selectedTime = null;
            if(!this.details) {
                this.details = {};
            }
			//part for single timepicker isRequired pending
            if(this.details.range) {
                this.details.range.startTime.title = this.details.range.startTime.title || 'start time';

                if(this.details.range && this.details.range.endTime) {
                    this.details.range.endTime.title = this.details.range.endTime.title || "end time";
                }

				if(!this.details.range.startTime.hasOwnProperty('isRequired')) {
					this.details.range.startTime.isRequired = true;
				}

				if(this.details.range.endTime && !this.details.range.endTime.hasOwnProperty('isRequired')){
					this.details.range.endTime.isRequired = true;
				}
                
                this.startTimeOpened = false;
                this.endTimeOpened = false;
            } else {
                this.opened = false;
            }
        }
        open() {
            this.opened = !this.opened;
        }
        openStartTime() {
            this.startTimeOpened = !this.startTimeOpened;
        }
        openEndTime() {
            this.endTimeOpened = !this.endTimeOpened;
        }
        _onTimeChange(){
            if(this.onTimeChange){
                this.onTimeChange();
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/timepicker/timepicker.component.js